import {HolidayProperty} from "./holiday-property";
import {WorkingDayProperty} from "./working-day-property";

export class WorkingTimeJsonProperties {
  public holidays: HolidayProperty[];
  public workingDays: WorkingDayProperty[];
  public workingDaysInWeek: any;
}
